import { rpc } from "#rpc";
import type { DepictOptions } from "@frend-digital/depict/server";
import type { AsyncReturnType } from "@frend-digital/utils";

export const fetchProductsClientAction = async ({
  cache,
  depictCategory,
  depictOptions,
  showAsOnSale,
  cursor,
}: {
  depictOptions: DepictOptions;
  depictCategory: string;
  cache: boolean;
  showAsOnSale?: boolean;
  cursor?: string;
}) => {
  const result = await rpc.depict.getProductList({
    cache,
    depictCategory,
    depictOptions,
    showAsOnSale,
    cursor,
  });

  return {
    sorts: result.sorts,
    filter: result.filter,
    nextCursor: result.nextCursor,
    total: result.total,
    categoryUUID: depictCategory,
    products: result.products,
  };
};

export type ProductListData = AsyncReturnType<typeof fetchProductsClientAction>;

export type Filter = Awaited<
  ReturnType<typeof fetchProductsClientAction>
>["filter"];
